import React from 'react';
import { Redirect } from 'react-router-dom';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import securePage from '../../components/authentication/SecurePage';
import queryString from 'query-string';
import { PageProps } from '../authentication/DefaultPage';

interface PropsFromRoute extends RouteComponentProps<{}> {
}

export const IncomingCall: React.FunctionComponent<PageProps & PropsFromRoute> = props => {
  let searchCriteria = '';
  if (props.location.search !== undefined) {
    const parsedQueryString = queryString.parse(props.location.search);
    if (parsedQueryString.phoneNumber !== undefined && parsedQueryString.phoneNumber !== null) {
      searchCriteria = queryString.stringify({ searchcriteria: parsedQueryString.phoneNumber });
    }
  }

  return (
    <Redirect to={`/search/?${searchCriteria}`} />
  );
};

export default (securePage(withRouter(IncomingCall)));
